import { Component, Input } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ButtonDirective } from "@components";

@Component({
  selector: "app-notification-header",
  standalone: true,
  imports: [TranslateModule, ButtonDirective],
  templateUrl: "./notification-header.component.html",
  styleUrl: "./notification-header.component.scss",
})
export class NotificationHeaderComponent {
  @Input() text = "";
}
